<div class="editor-menu">
    <div class="menu-group">
        <button nbButton status="basic" size="tiny" (click)="gotoEditor('layout')">Layout</button>
        <button nbButton status="basic" size="tiny" (click)="gotoEditor('header')">Header</button>
        <button nbButton status="basic" size="tiny" (click)="gotoEditor('footer')">Footer</button>
    </div>
    <div class="menu-group">
        <button nbButton status="basic" size="tiny">Home Page</button>
        <button nbButton status="basic" size="tiny">Category Page</button>
        <button nbButton status="basic" size="tiny">Product Page</button>
    </div>
    <div class="menu-group">
        <button nbButton status="basic" size="tiny">Contact Us</button>
        <button nbButton status="basic" size="tiny">About Us</button>
        <button nbButton status="basic" size="tiny">Policies</button>
    </div>
    <div class="menu-group">
        <button nbButton status="basic" size="tiny">News Letter</button>
        <button nbButton status="basic" size="tiny">Social Media</button>
        <button nbButton status="basic" size="tiny">Blog</button>
    </div>
    <div class="menu-group">
        <button nbButton status="basic" size="tiny">News Letter</button>
        <button nbButton status="basic" size="tiny">Social Media</button>
        <button nbButton status="basic" size="tiny">Blog</button>
    </div>
</div>
<!-- <div class="sub-menu-container">
    <router-outlet></router-outlet>
</div> -->
<!-- <router-outlet></router-outlet> -->

<!-- <div class="sub-menu-container" [showSubmenu]="showSubmenu" kvCollapseSubmenu>
    <router-outlet></router-outlet>
</div> -->
